import React from 'react';
import InputGroup from '../../InputGroup';

import { Field } from 'redux-form';

const EmailInput = () => (
    <Field
        name="email"
        component={InputGroup}
        type="email"
        label="Email address"
        autocomplete="email"
        placeholder="Email Address"
        maxLength={100}
    />
);

export default EmailInput;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/EmailInput.jsx